module.exports = {"svg":{"$":{"t":"1541406659717","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"3764","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M534.884848 159.418182 489.115152 205.187879 763.60404 479.676768 116.363636 479.676768 116.363636 544.323232 763.60404 544.323232 489.115152 818.812121 534.884848 864.581818 887.466667 512Z","p-id":"3765"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/to-right.svg
// module id = almc
// module chunks = 2